class DocumentsTreeController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, alertsAndNotificationsService, StorageService, MESSAGECONSTANTS) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.StorageService = StorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    $onInit() {
        this.isJobMatchDocumentsAvailable = false;
        this.isCandidateDocumentsAvailable = false;
        this.onDataChangeCount = 1;
        this._setDocumentTreeFolderVisibility();
        this._setCandidateDocuments();
    }
    $onChanges(changes) {
        if (changes && changes.folders && this.onDataChangeCount > 0) {
            this.$timeout(() => {
                this._setDocumentTreeFolderVisibility();
                this._setCandidateDocuments();
            }, 100);
            this.onDataChangeCount += 1;
        }
    }
    _setCandidateDocuments() {
        if (this.availableDocumentsInFolders && this.availableDocumentsInFolders.length > 0) {
            this.availableDocumentsInFolders.every(document => {
                if (!document.isJobMatchDocument) {
                    this.isCandidateDocumentsAvailable = true;
                    return false;
                }
                return true;
            });
        }
    }
    _setDocumentTreeFolderVisibility() {
        if (this.folders.length > 0) {
            this.folders.map(parentFolder => {
                if (parentFolder.documents.length > 0) {
                    parentFolder.showParentFolder = true;
                    this.isJobMatchDocumentsAvailable = true;
                }
                else {
                    parentFolder.showParentFolder = false;
                }
                parentFolder.showActions = false;
                if (parentFolder.folders && parentFolder.folders.length > 0) {
                    parentFolder.folders.map(childFolder => {
                        childFolder.showChildFolder = childFolder.documents.length > 0 ? true : false;
                        childFolder.showActions = false;
                        if (childFolder.showChildFolder) {
                            parentFolder.showParentFolder = true;
                        }
                    });
                }
            });
        }
    }
    remove(scope) {
        scope.remove();
    }
    toggle(scope) {
        scope.toggle();
    }
    moveLastToTheBeginning() {
        let a = this.data.pop();
        this.data.splice(0, 0, a);
    }
    collapseAll() {
        this.$scope.$broadcast('angular-ui-tree:collapse-all');
    }
    expandAll() {
        this.$scope.$broadcast('angular-ui-tree:expand-all');
    }
    onChangeViewType(viewType) {
        this.showList = viewType == 'list';
    }
    visible(item) {
        return !(this.query && this.query.length > 0
            && item.title.indexOf(this.query) == -1);
    }
    findNodes() {
    }
    selectFolder(folder, type) {
        if (type != 'fromDocumentSelect') {
            this._resetSelectedCandidateDocuments();
        }
        folder.isJobMatchFolders = this.isJobMatchFolders;
        if (this.onSelectFolder) {
            this.onSelectFolder({ selectedFolder: folder });
        }
    }
    addFolder(folder) {
        if (this.onAddFolder) {
            this.onAddFolder({ parentFolder: folder });
        }
    }
    editFolder(folder) {
        if (this.onEditFolder) {
            this.onEditFolder({ folder: folder });
        }
    }
    deleteFolder(folder) {
        if (this.onDeleteFolder) {
            this.onDeleteFolder({ folder: folder });
        }
    }
    moveFolder(folder) {
        if (this.onMoveFolder) {
            this.onMoveFolder({ folder: folder });
        }
    }
    selectFolderWithDocuments(folder) {
        folder.isJobMatchFolders = this.isJobMatchFolders;
        if (this.onSelectFolderWithDocuments) {
            this.onSelectFolderWithDocuments({ folder: folder });
        }
    }
    selectAndDeselectDocument(document, folder) {
        if (this.onSelectAndDeselectDocument) {
            this.onSelectAndDeselectDocument({ document: document, folder: folder });
        }
    }
    _resetSelectedCandidateDocuments() {
        if (this.folders.length > 0) {
            this.folders.map(parentFolder => {
                if (parentFolder.documents.length > 0) {
                    parentFolder.documents.map(doc => {
                        doc.isDocumentSelected = false;
                    });
                }
                if (parentFolder.folders && parentFolder.folders.length > 0) {
                    parentFolder.folders.map(childFolder => {
                        if (childFolder.documents.length > 0) {
                            childFolder.documents.map(doc => {
                                doc.isDocumentSelected = false;
                            });
                        }
                    });
                }
            });
        }
    }
    onDocumentSelect(document, folder) {
        if (!this.isAvailableDocuments) {
            this._resetSelectedCandidateDocuments();
            document.isDocumentSelected = true;
            this.selectFolder(folder, 'fromDocumentSelect');
        }
    }
}
DocumentsTreeController.$inject = ['$scope', '$rootScope', '$timeout', 'alertsAndNotificationsService', 'StorageService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './documents-tree.html';
import * as TEMPLATE from 'raw-loader!./documents-tree.html';
export const DocumentsTreeComponent = {
    selector: 'documentsTree',
    component: {
        bindings: {
            folders: "<",
            isJobMatchFolders: "<",
            isAvailableDocuments: '<',
            availableDocumentsInFolders: '<',
            customStyle: '@',
            onSelectFolder: "&",
            onAddFolder: "&",
            onEditFolder: "&",
            onDeleteFolder: "&",
            onMoveFolder: "&",
            onSelectFolderWithDocuments: "&",
            onSelectAndDeselectDocument: '&'
        },
        controller: DocumentsTreeController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/documentsTree/documents-tree.html'
    }
};
//# sourceMappingURL=documents-tree.component.js.map